module.exports = __webpack_public_path__ + "img/eco-guest.90cfc105.png";